import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ValoginComponent } from './valogin.component';

const routes: Routes = [
    {
    path: '',
    component: ValoginComponent,
    data: {
        title: 'VA login'
    }
}
];

@NgModule({
    declarations: [ValoginComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,  
    FormsModule,  
    RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ValoginModule { }
